module.exports = __webpack_public_path__ + "img/HoF-wireframes@2x.d0deb2e2.png";